import Vue from 'vue'
import Vuex from 'vuex'

import User from '@/models/User'

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const USER_ADDRESS_BOOK = 'USER_ADDRESS_BOOK'
export const REMOVE_ADDRESS_BOOK_ITEM = 'REMOVE_ADDRESS_BOOK_ITEM'
export const SET_ACTIVE_GROUP = 'SET_ACTIVE_GROUP'
export const SET_ACTIVE_GROUP_ID = 'SET_ACTIVE_GROUP_ID'
export const SET_ACTIVE_WALLET = 'SET_ACTIVE_WALLET'
// export const GROUP_ADDRESS_BOOK = 'GROUP_ADDRESS_BOOK';

Vue.use(Vuex)

const state = {
  user: User.from(localStorage.token),
  token: localStorage.getItem('token'),
  orgIndex: localStorage.getItem('oi') || 0,
  isLoggedIn: !!localStorage.getItem('token'),
  userAddressBook: null,
  active_group_id: null,
  active_group: null,
  active_wallet_id: null,
  public_key: null
}

const mutations = {
  [LOGIN]: (state, data) => {
    state.token = data.token
    state.user = User.from(data.token)
    state.active_wallet_id = data.wallet_id
    state.public_key = data.public_key
    state.active_group_id = data.group_id
    state.orgIndex = 0
    localStorage.setItem('token', data.token)
  },
  [LOGOUT]: (state) => {
    state.token = null
    state.user = null
    state.active_group = null
    state.active_group_id = null
    state.active_wallet_id = null
    state.public_key = null
    localStorage.removeItem('token')
    Vue.set(state, 'userAddressBook', [])
  },
  [USER_ADDRESS_BOOK]: (state, data) => {
    Vue.set(state, 'userAddressBook', data)
  },

  [REMOVE_ADDRESS_BOOK_ITEM]: (state, address_book_entry) => {
    const index = state.userAddressBook.findIndex(entry => entry.address_book_entry == address_book_entry)
    if (index != -1) {
      state.userAddressBook.splice(index, 1)
    }
  },

  [SET_ACTIVE_GROUP_ID]: (state, group_id) => {
    state.active_group_id = group_id
  },
  [SET_ACTIVE_GROUP]: (state, group) => {
    state.active_group = group
    state.active_group_id = group.group_id
  },
  [SET_ACTIVE_WALLET]: (state, active_wallet) => {
    state.active_wallet_id = active_wallet.wallet_id
    state.public_key = active_wallet.public_key
  }

}

const getters = {
  currentUser: state => {
    return state.user
  },
  userAddressBookItem: state => public_key => state.userAddressBook ? state.userAddressBook.find(item => item.public_key == public_key) : null,
  userAddressBookItemById: state => address_book_entry => state.userAddressBook ? state.userAddressBook.find(item => item.address_book_entry == address_book_entry) : null,
  userAddressBook: state => state.userAddressBook,
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  activeGroup: state => state.active_group,
  activeWallet: state => state.active_wallet_id,
  publicKey: state => state.public_key
}

const actions = {
  login ({ commit }) {
    commit(LOGIN)
  },

  logout ({ commit }) {
    commit(LOGOUT)
  }
}

export default new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions

})
